
const jQuery = require('jquery');
window.$ = window.jQuery = jQuery;

require('tiny-slider');
require('jquery-match-height');

$('.js-hamburger').click(function () {
    $(this).toggleClass('is-active');

    $('.main-nav').toggleClass('main-nav--active');

});

var stageslider = tns({
    container: '.stages-slider',
    mode: "gallery",
    controls: false,
    nav: false,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayButtonOutput: false,
    speed: 2500


});

var jobsslider = tns({
    container: '.jobs-slider',
    controls: false,
    nav: false,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayButtonOutput: false,
    speed: 500

});







